/**
 * Converts a tab label (e.g., "Life Cycle Assessment") to a snake_case slug (e.g., "life_cycle_assessment").
 * It lowercases the string and replaces non-alphanumeric characters or spaces with underscores,
 * collapsing multiple underscores into one.
 *
 * @param {string} label - The human-readable tab label.
 * @returns {string} The snake_case slug representation.
 */
export function labelToSlug(label) {
	if (!label) return "";
	const lower = label.toLowerCase();
	let slug = "";
	for (let i = 0; i < lower.length; i++) {
		const ch = lower[i];
		if ((ch >= "a" && ch <= "z") || (ch >= "0" && ch <= "9")) {
			slug += ch;
		} else if (slug[slug.length - 1] !== "_") {
			slug += "_";
		}
	}
	return slug.replace(/^_|_$/g, "");
}

/**
 * Maps a snake_case slug back to one of the valid tab labels from allowedLabels (case-insensitive
 * and format-insensitive match), returning the original human-readable label if a match is found,
 * or null if not found.
 *
 * @param {string} slug - The snake_case slug from the URL.
 * @param {string[]} allowedLabels - The list of valid, human-readable tab labels.
 * @returns {string|null} The matching human-readable label, or null if no match is found.
 */
export function slugToLabel(slug, allowedLabels) {
	if (!slug || !Array.isArray(allowedLabels)) return null;
	const targetSlug = labelToSlug(slug);
	for (const label of allowedLabels) {
		if (labelToSlug(label) === targetSlug) {
			return label;
		}
	}
	return null;
}
